// @flow

import styled from "styled-components";
import Icon from "../../_static/Icons";
import { buildText } from "../../_atom/Text/index";
import { fontCondensedNormal, fontMedium } from "../../_static/Typography";

export const QDText = styled.span`
  font-family: ${fontMedium};
  display: flex;
  flex-direction: column;
`;

export const QDamount = styled(
  buildText({
    tag: "span",
    uppercase: true
  })
)`
  font-family: ${fontMedium};
  font-size: ${(props) => (props.isMicro ? "12px" : "14px")};
`;

export const QDlabel = styled(
  buildText({
    tag: "span",
    uppercase: true
  })
)`
  font-size: ${(props) => (props.isAbbreviated ? "12px" : "10px")};
  font-family: ${fontCondensedNormal};
`;

export const QDIcon = styled(Icon)`
  margin-right: 8px;
`;
